import styled, { keyframes } from 'styled-components';

const WIPER_WIDTH = 50;

const WiperAnimation = keyframes`
    0% {
        left: -${WIPER_WIDTH}px;
    }
    
    20%, 100% {
        left: calc(100vw + ${WIPER_WIDTH}px);
    }
`;

export const Wiper = styled.div`
    position: relative;
    z-index: 1;
    height: 100%;
    width: 1px;
    opacity: 75%;
    background-color: ${({ theme }) => theme.Surface.secondary};
    box-shadow: 0 0 ${WIPER_WIDTH}px ${WIPER_WIDTH}px ${({ theme }) => theme.Surface.secondary};
    animation: ${WiperAnimation} 5s linear infinite;
    transform: skew(315deg);
`;
